import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";
import IriseVideo from "../assets/videos/KY1915iRISEInitiativeGeneralWelcome.mp4";
// import Waiver from "../../src/assets/img/1918/waiver.jpg";
import Attention from "../../src/assets/img/1918/irise_attention.png";

const LittleEye_Content = [
  {
      format: bodyHelperTypes.paragraphs,
      order: 10,
      content: [
          <div style={{textAlign: "center"}}>
              <a href="https://us06web.zoom.us/meeting/register/EcV98VonRAGKFN2BYByWMw#/registration"><img src={Attention} alt="1915i Waiver" width="800" height="600"></img></a>
          </div>

      ]

  },

  {
    format: bodyHelperTypes.title,
    order: 11,
    content:
      "1915(i) RISE Initiative – Home and Community-Based Services for Adults with Serious Mental Illness",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 20,
    content: [
      <>
        <b>Recovery. Independence. Support. Engagement.</b>
        <br />
        <br />
        RISE reflects the initiative's focus on helping individuals rise above
        their challenges through services that promote recovery, independence &
        community engagement. <br />
        <br />
        <video className="container" width="750" height="500" controls>
          <source src={IriseVideo} type="video/mp4" />
        </video>
      </>,
      <>
        The 1915(i) RISE Initiative is a Medicaid program that offers Recovery,
        Independence, Support, and Engagement to Kentuckians with serious mental
        illness (SMI). Through this program, eligible adults can access home and
        community-based services (HCBS) that support independent living, reduce
        reliance on institutional care, and promote long-term recovery.
      </>,
      <>
        The 1915(i) RISE Initiative is administered by the Department for
        Medicaid Services (DMS) in partnership with the Department for
        Behavioral Health, Developmental and Intellectual Disabilities (DBHDID).
      </>,
      <>
        The program is designed to improve the quality of life for individuals
        with SMI by offering access to up to 10 Medicaid-reimbursable services
        delivered in community-based settings, guided by a Person-Centered
        Service Plan (PCSP).
      </>,
    ],
  },
  {
    format: bodyHelperTypes.title,
    order: 30,
    content:
      "The goal of the 1915(i) RISE Initiative is to help Kentuckians with SMI secure housing, access education and employment, while thriving in their communities, and avoiding institutionalization.",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 40,
    content: [<></>],
  },
  {
    format: bodyHelperTypes.title,
    order: 50,
    content: "Covered Services Under the 1915(i) RISE Initiative",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 60,
    content: [
      <>
        The following 10 services are available to eligible participants through
        the 1915(i) RISE Initiative, delivered based on individualized needs
        outlined in each participant’s PCSP:
        <br />
        <br />
        <ol>
          <li>
            <b>Assistive Technology</b>
            <br />
            Provides access to supportive devices or tools that promote
            independence and engagement in the community. Examples include
            medication dispensers, visual timers, phone-based reminders, and
            smart home tools.
            <br />
            <br />
          </li>
          <li>
            <b>Case Management</b>
            <br />
            A certified case manager coordinates services for the participant,
            ensures timely access to supports, monitors service effectiveness,
            and works with the participant to adjust services as needs evolve.
            <br />
            <br />
          </li>
          <li>
            <b>Housing and Tenancy Supports</b>
            <br />
            Services help participants locate, secure, and maintain stable
            housing. Activities include housing search, landlord communication,
            lease agreement review, eviction prevention planning, and basic
            tenancy skills training.
            <br />
            <br />
          </li>
          <li>
            <b>In-Home Independent Living Supports</b>
            <br />
            Hands-on assistance with daily tasks to support safe and stable
            independent living. Includes meal preparation, cleaning, home
            organization, budgeting, medication reminders, and personal care
            prompts.
            <br />
            <br />
          </li>
          <li>
            <b>Medication Management</b>
            <br />
            Supports participants in understanding and managing their prescribed
            medications. Services include medication education, coordination
            with prescribers, reminders, and adherence coaching.
            <br />
            <br />
          </li>
          <li>
            <b>Planned Respite for Caregivers</b>
            <br />
            Temporary relief for unpaid caregivers to prevent burnout and
            promote participant stability. Services are scheduled in advance and
            may occur in the home or another approved setting.
            <br />
            <br />
          </li>
          <li>
            <b>Supervised Residential Care</b>
            <br />
            Provides a structured, staffed living environment for participants
            who require additional supervision and support as a transition from
            or alternative to institutional settings.
            <br />
            <br />
          </li>
          <li>
            <b>Supported Education</b>
            <br />
            Helps participants enroll in and succeed at General Education
            Development (GED) programs, community college, certification
            courses, or vocational education. Services include enrollment
            assistance, advocacy, study skills training, and school system
            navigation.
            <br />
            <br />
          </li>
          <li>
            <b>Supported Employment (Individual Placement and Support) </b>
            <br />
            One-on-one job development, placement, and retention services that
            help individuals with SMI enter or re-enter competitive, integrated
            employment. Support may continue on or off the job.
            <br />
            <br />
          </li>
          <li>
            <b>Transportation (Non-Medical)</b>
            <br />
            Covers transportation to behavioral health services, employment,
            education, and other community activities identified in the PCSP
            when no other transportation is available.
            <br />
            <br />
          </li>
        </ol>
      </>,
    ],
  },
  {
    format: bodyHelperTypes.title,
    order: 70,
    content: "Participant Eligibility Criteria",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 80,
    content: [
      <>
        To be eligible, you must:
        <br />
        <ul>
          <li>
            Be <b>18 or older</b>.
          </li>
          <li>
            Be enrolled in <b>Kentucky Medicaid</b>.
          </li>
          <li>
            Have a <b>primary diagnosis of SMI</b>, such as schizophrenia,
            bipolar disorder, or major depressive disorder with functional
            impairment.
          </li>
          <li>
            May also have a <b>co-occurring substance use disorder (SUD)</b>.
          </li>
          <li>
            Experience one or more of the following:
            <ul>
              <li>
                History of behavioral health hospitalizations in the past two
                years.
              </li>
              <li>
                History of clinically significant symptoms of mental illness for
                at least two years.
              </li>
              <li>
                History of episodic debilitating behavioral health symptoms
                expecting to continue for a two-year period.
              </li>
            </ul>
          </li>
          <li>
            Demonstrate functional need in two or more functional domains such
            as social interaction, personal care, or physical or intellectual
            functioning.
          </li>
        </ul>
        A 1915(i) RISE Initiative agent will conduct a formal{" "}
        <b>assessment and screening</b> to determine functional eligibility. See{" "}
        <a href="https://apps.legislature.ky.gov/law/kar/titles/907/016/010/">
          907 KAR 16:010
        </a>{" "}
        for further eligibility details.
      </>,
    ],
  },
  {
    format: bodyHelperTypes.title,
    order: 90,
    content: "How to Apply",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 100,
    content: [
      <>
        If you are interested in applying for 1915(i) RISE services, the
        application process includes the following steps:
      </>,
      <>
        <b>Step 1: Referral</b>
        <br />
        Participants are referred by a provider, care team member, or
        self-referral through an email to{" "}
        <a href="mailto:1915iRISEInitiative@ky.gov">
          1915iRISEInitiative@ky.gov
        </a>{" "}
        or by calling 502-564-9189.
      </>,
      <>
        <b>Step 2: Screening </b>
        <br />A designated 1915(i) RISE Initiative specialist will follow up
        within three business days to begin the eligibility review.
      </>,
      <>
        <b>Step 3: Assessment</b>
        <br />
        The participant completes the assessment and a functional eligibility
        screening with a trained assessor.
      </>,
      <>
        <b>Step 4: Service Planning</b>
        <br />
        If found eligible, the participant selects a case manager to collaborate
        with to create a Person-Centered Service Plan (PCSP), identifying which
        1915(i) RISE services will best meet their needs
      </>,
      <>
        <b>Step 5: Service Delivery</b>
        <br />
        Services begin with the participant’s selected providers. Progress is
        reviewed regularly to ensure services remain appropriate.
      </>,
      <>
        For step-by-step instructions, visit our{" "}
        <a href="/1915iriseinitiative-participant">
          {" "}
          1915(i) RISE Initiative Partcipant
        </a>{" "}
        page, or email us at{" "}
        <a href="mailto:1915iRISEInitiative@ky.gov">
          1915iRISEInitiative@ky.gov.
        </a>{" "}
        For additional information see{" "}
        <a href="/1915iriseinitiative-faq">
          1915(i) RISE Initiative Participant FAQ
        </a>
        .
      </>,
      <>
        <b>Rights and Responsibilities</b>
        <br />
        All 1915(i) RISE participants have the right to:
        <ul>
          <li>Choose their provider(s).</li>
          <li>Be involved in their service planning and delivery.</li>
          <li>Access services in the most inclusive setting possible.</li>
          <li>
            Receive written notice of decisions affecting their eligibility or
            services.
          </li>
          <li>File an appeal or grievance without fear of retaliation.</li>
        </ul>
      </>,
      <>
        1915(i) RISE providers are responsible for:
        <ul>
          <li>Maintaining documentation in accordance with Medicaid rules.</li>
          <li>
            Delivering services as outlined in the PCSP and in line with
            participants’ goals.
          </li>
          <li>Coordinating care across systems when appropriate.</li>
          <li>Reporting critical incidents or service disruptions.</li>
        </ul>
      </>,
    ],
  },
  {
    format: bodyHelperTypes.title,
    order: 110,
    content: "Provider Enrollment",
  },
  {
    format: bodyHelperTypes.paragraphs,
    order: 120,
    content: [
      <>
        The 1915(i) RISE Initiative offers an opportunity for providers across
        sectors to deliver impactful services and expand their scope of
        Medicaid-covered supports.
      </>,
      <>
        Organizations that may be eligible include:
        <ul>
          <li>Community Mental Health Centers (CMHCs).</li>
          <li>Behavioral health agencies.</li>
          <li>Housing support providers.</li>
          {/* <li>Peer-run organizations.</li> */}
          <li>Employment and education agencies.</li>
          <li>Care coordination and case management entities.</li>
        </ul>
        Providers may deliver one or more services, with the exception of case
        management, and are reimbursed via fee-for-service through Kentucky
        Medicaid.
      </>,
      <>
        Provider requirements:
        <ul>
          <li>Must be enrolled as a Medicaid provider.</li>
          <li>
            Must complete 1915(i) RISE certification and any required staff
            qualifications.
          </li>
          <li>
            Must attend required training on billing, documentation, and
            compliance.
          </li>
          <li>
            Must follow service-specific fidelity standards and Person-Centered
            Planning guidelines.
          </li>
        </ul>
      </>,
      <>
        To get started, visit our{" "}
        <a href="/1915iriseinitiative-provider">For Providers</a> page, or email
        us at{" "}
        <a href="mailto:1915iRISEprovider@ky.gov">1915iRISEprovider@ky.gov</a>.
      </>,
      <>
        <b>
          For Additional Information, see{" "}
          <a href="/1915iriseinitiative-provider-faq">
            1915(i) RISE Initiative Provider FAQ
          </a>
          .
        </b>
      </>,
    ],
  },
  // {
  //     format: bodyHelperTypes.title,
  //     order: 130,
  //     content: "What If I Already Receive Services?"
  // },
  // {
  //     format: bodyHelperTypes.paragraphs,
  //     order: 140,
  //     content: [
  //         <>
  //             The 1915(i) RISE Initiative is designed to add to your current supports — not replace them. Your case manager will help you:
  //             <ul>
  //                 <li>Avoid duplication of services.</li>
  //                 <li>Keep the providers you trust.</li>
  //                 <li>Coordinate with other programs (e.g., 1915[c], Voc Rehab).</li>
  //             </ul>
  //         </>
  //     ]
  // },
  // {
  //     format: bodyHelperTypes.title,
  //     order: 150,
  //     content: "Your Rights as a 1915(i) RISE Participant"
  // },
  // {
  //     format: bodyHelperTypes.paragraphs,
  //     order: 160,
  //     content: [
  //         <>
  //             You have the right to:
  //             <ul>
  //                 <li>Be treated with dignity and respect.</li>
  //                 <li>Choose your services and providers.</li>
  //                 <li>Receive services in the community.</li>
  //                 <li>File complaints or appeals.</li>
  //                 <li>Be involved in decisions that affect your care.</li>
  //             </ul>
  //             For more information, visit [Participant Rights & Complaints].
  //         </>
  //     ]
  // }
];

export default LittleEye_Content;
